'use strict';

import angular from 'angular';

import './style.css';


export default function(opts) {
	return function($window, $interpolate, $uibModal) {
		'ngInject';

		return {
			link: postLink,
			scope: {
				$instance: '=instance',
				$context: '<context',
				$$permission: '<permission',
				onSuccess: '<',
				templateUrl: '@',
			}
		};

		function postLink(scope, element, attrs) {
			if (!scope.$context) scope.$context = {};
			scope.$reload = function() {
				$window.location.reload();
			}

			var successUrl = element.attr('success-url');

			var modalOpts = {
				backdrop: 'static',
				controller: function() {},
				scope: scope,
			};
			angular.extend(modalOpts, opts);

			// We pass the scope to the customTemplateUrl if it exists.  We then
			// define the template option using the output of this function.
			if (typeof opts.scopedTemplateUrl === 'function') {
				modalOpts.templateUrl = opts.scopedTemplateUrl(scope);
			}

			// Make the incident, context and instance available in resolve functions
			if (!modalOpts.resolve) modalOpts.resolve = {};
			if (scope.$context) modalOpts.resolve.$context = () => scope.$context;
			if (scope.$instance) modalOpts.resolve.$instance = () => scope.$instance;
			if (scope.templateUrl) modalOpts.templateUrl = scope.templateUrl;

			// Disable the button when the user does not have permission
			if (scope.$$permission !== undefined && !scope.$$permission) {
				element.addClass('disabled');
				attrs.$set('disabled', true);
				return;
			}

			element.addClass('btn-rest');

			// Handle the click
			element.on('click', function() {
				this.blur();
				if (element.hasClass('busy')) return;
				element.addClass('busy');
				if (scope.$instance) var instanceCopy = angular.copy(scope.$instance);
				var modal = $uibModal.open(modalOpts);
				modal.opened.finally(function() {
					element.removeClass('busy');
				});
				modal.result.then(function closed(result) {
					if (scope.$instance) angular.merge(instanceCopy, result);
					if (scope.onSuccess) {
						scope.onSuccess(result)
					}
					if (successUrl) {
						var parsedSuccessUrl = $interpolate(successUrl)({
							$instance: scope.$instance,
							$context: scope.$context,
							$result: result,
						});
						$window.location.href = parsedSuccessUrl;
					}
				}, function rejected(result) {
					if (scope.$instance) angular.merge(scope.$instance, instanceCopy);
					if (scope.onError) {
						scope.onError(result)
					}
				});
			});
		}
	}
}
